import React, { createContext, Fragment } from "react"
import { v4 as uuidv4 } from "uuid"
import { useShallow } from "zustand/react/shallow"
import { sanitizeValue } from "../../../../../utils"

// components
import Header from "../components/Header/Header"
import AdverseEvents from "./AdverseEvents/AdverseEvents"
import CTGGroupTotals from "./CTGGroupTotals"

// context
import useAuthoringDataStore from "containers/studies/Study/subcomponents/Authoring/hooks/stores/useAuthoringDataStore"
import useResultsTableViewStore from "containers/studies/Study/subcomponents/Authoring/hooks/stores/useResultsTableViewStore"

import "./AdversePreview.scss"

export const AEContext = createContext(null)

const AdversePreview = (props) => {
  let { schema = null } = props
  const { formData } = useAuthoringDataStore(
    useShallow((state) => ({
      formData: state.formData,
    }))
  )

  const { tableView } = useResultsTableViewStore()

  let view = tableView
  if (view === "global") view = "ctg"

  let data = formData?.results?.adverse_events?.adverse_events_table?.[view]
  let bgColor = "rgb(235, 221, 253)"

  return (
    <AEContext.Provider
      value={{
        data,
        view,
        schema,
      }}
    >
      <table className="adverse-preview-table results-table">
        <tbody>
          {Object?.keys(schema?.properties?.[view]?.properties)?.map((key) => {
            let fieldSchema = schema.properties[view].properties
            return (
              <tr key={uuidv4()}>
                <td
                  style={{
                    backgroundColor: bgColor,
                    fontWeight: "bold",
                    width: 250,
                  }}
                >
                  {fieldSchema?.[key]?.title}
                </td>
                <td>{sanitizeValue(data?.[key])}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
      <Header
        title="Reporting Groups"
        bgColor={bgColor}
        arms={formData?.results?.adverse_events?.adverse_events_table?.[view]?.groups || []}
        schema={schema}
        view={view}
        showAdverseEventsProps={true}
      />
      <table className="adverse-preview-table authoring-table-component results-table">
        <tbody>
          {view === "ctg" && (
            <Fragment key={uuidv4()}>
              <tr>
                <td
                  style={{ fontWeight: "bold" }}
                  colSpan={data?.groups?.length + 2}
                >
                  All Cause Mortality
                </td>
              </tr>
              <CTGGroupTotals
                type="all_cause_mortality_group_total"
                bgColor={bgColor}
              />
            </Fragment>
          )}
        </tbody>
      </table>
      <AdverseEvents
        title="Serious Adverse Events"
        totalType={"serious_adverse_event_group_total"}
        type={"serious_adverse_events"}
        statSchema={"serious_adverse_event_stat"}
        bgColor={bgColor}
      />
      <AdverseEvents
        title="Non-Serious Adverse Events"
        totalType={"non_serious_adverse_event_group_total"}
        type={"non_serious_adverse_events"}
        statSchema={"non_serious_adverse_event_stat"}
        bgColor={bgColor}
      />
    </AEContext.Provider>
  )
}

export default AdversePreview
